import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDueDay } from "../../../../../store/donation/actions";
import { State } from "../../../../../store/state";
import { DatePicker } from "../../../../shared/DatePicker/DatePicker";
import { ToolTip } from "../../../../shared/ToolTip/ToolTip";
import { Wrapper, DateBoxWrapper, DateTextWrapper, DateText } from "../../Vipps/VippsDatePicker/VippsDatePicker.style";
import { getNextChargeDate, isIrregularChargeDay } from "./avtalegirodates";
import { DatePickerInputConfiguration } from "../../../../../../DatePicker/DatePickerInput";
import { Dispatch } from "@reduxjs/toolkit";
import { DonationActionTypes } from "../../../../../store/donation/types";
const tooltipText = "Vi må av tekniske grunner melde inn trekk til bankene tidligere enn din valgte trekkdato, derfor utsettes første trekk med én måned. Du kan velge en annen trekkdato om du ønsker å trekkes tidligere.";
export const AvtaleGiroDatePicker: React.FC<{
  configuration: DatePickerInputConfiguration;
}> = t0 => {
  const $ = _c(23);
  const {
    configuration
  } = t0;
  const dispatch = useDispatch();
  const dueDay = useSelector(_temp);
  const [selectedDueDay, setSelectedDueDay] = useState(dueDay);
  const [, setNextChargeDate] = useState();
  let t1;
  if ($[0] !== dispatch || $[1] !== selectedDueDay) {
    t1 = () => {
      setNextChargeDate(getNextChargeDate(selectedDueDay));
      dispatch(setDueDay(selectedDueDay));
    };
    $[0] = dispatch;
    $[1] = selectedDueDay;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== selectedDueDay) {
    t2 = [selectedDueDay];
    $[3] = selectedDueDay;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== configuration.payment_date_format_template || $[6] !== configuration.payment_date_last_day_of_month_template || $[7] !== dueDay) {
    t3 = dueDay === 0 ? configuration.payment_date_last_day_of_month_template : configuration.payment_date_format_template.replace("{{date}}", dueDay.toString());
    $[5] = configuration.payment_date_format_template;
    $[6] = configuration.payment_date_last_day_of_month_template;
    $[7] = dueDay;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <DateText>{t3}</DateText>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== selectedDueDay) {
    t5 = isIrregularChargeDay(selectedDueDay) && <ToolTip text={tooltipText} />;
    $[11] = selectedDueDay;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <DateTextWrapper>{t4}{t5}</DateTextWrapper>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = date => {
      setSelectedDueDay(date);
    };
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== configuration || $[18] !== dueDay) {
    t8 = <DateBoxWrapper><DatePicker selected={dueDay} onChange={t7} onClickOutside={_temp2} configuration={configuration} /></DateBoxWrapper>;
    $[17] = configuration;
    $[18] = dueDay;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t8) {
    t9 = <Wrapper>{t6}{t8}</Wrapper>;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
function _temp(state) {
  return state.donation.dueDay;
}
function _temp2() {}